import services from '@/config/services'

export default class ClientiInUscitaService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async clientiInUscita(year, months) {
    const url = `${this.baseUrl}/clienti-in-uscita`;
  
    try {
      let res = await this.http.post(url, { 
        year: year,
        months: months
      });
      
      if (res.data.success) {
        return {
          data: res.data.data,
          count: res.data.count
        };
      }
      
      return {
        data: { vt4: [], sospensioni: [] },
        count: { vt4: 0, sospensioni: 0 }
      };
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return {
        data: { vt4: [], sospensioni: [] },
        count: { vt4: 0, sospensioni: 0 }
      };
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async sendItems(items) {
    const url = `${this.baseUrl}/clienti-in-uscita/save`;
    
    try {
      const res = await this.http.post(url, { items });
      if (!res.data.success) {
        throw new Error(res.data.message || 'Errore nel salvataggio dei record');
      }
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    }
  }

  async getFileHistory() {
    const url = `${this.baseUrl}/clienti-in-uscita/infoFileGenerati`;
    
    try {
      const res = await this.http.get(url);
      if (!res.data.success) {
        throw new Error(res.data.message || 'Errore nel recupero dello storico file');
      }
      return res.data.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    }
  }

  async downloadFile(path) {
    const url = `${this.baseUrl}/clienti-in-uscita/downloadFile?path=${encodeURIComponent(path)}`;
    try {
      const res = await this.http.get(url, { responseType: 'blob' });
      return res.data; // questo è il blob
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    }
  }
}
